import api from './api';

export type RodoDocDbStatus = 'draft' | 'archiwalny' | 'opublikowany';
export type RodoDocFormStatus = 'draft' | 'archiwalny' | 'publikuj';

export interface RodoDocumentDto {
  id: number;
  slug: string;
  title_pl: string;
  file_url: string | null;
  status: RodoDocDbStatus;
  sort_order?: number | null;
  created_at: string;
  updated_at: string;
}

export async function listPublic(): Promise<RodoDocumentDto[]> {
  const { data } = await api.get('/rodo-documents/public');
  return data?.data ?? data ?? [];
}

export async function listAll(): Promise<RodoDocumentDto[]> {
  const { data } = await api.get('/rodo-documents');
  return data ?? [];
}

export async function createDoc(payload: { slug: string; title_pl: string; file_url?: string | null; status: RodoDocFormStatus; sort_order?: number | null }): Promise<RodoDocumentDto> {
  const { data } = await api.post('/rodo-documents', payload);
  return data;
}

export async function updateDoc(id: number, payload: { slug?: string; title_pl?: string; file_url?: string | null; status?: RodoDocFormStatus; sort_order?: number | null }): Promise<{ success: boolean }>{
  const { data } = await api.put(`/rodo-documents/${id}`, payload);
  return data;
}

export async function deleteDoc(id: number): Promise<{ success: boolean }>{
  const { data } = await api.delete(`/rodo-documents/${id}`);
  return data;
}

export async function uploadPdf(file: File): Promise<{ success: boolean; file_url: string; file_name: string; size: number }>{
  const form = new FormData();
  form.append('file', file);
  const { data } = await api.post('/rodo-documents/upload', form, { headers: { 'Content-Type': 'multipart/form-data' } });
  return data;
}


